<template>
  <div :class="className" :style="{ height: height, width: width }"></div>
</template>

<script>
import echarts from "echarts";
require("echarts/theme/macarons");
import resize from "./mixins/resize"; // 确保存在且正确

export default {
  name: "BarChart",
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "350px"
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartInfo: {
      type: Object,
      default: () => ({})
    },
    // 核心数据：series 和 xAxis
    chartData: {
      type: Object,
      required: true,
      validator: (val) => 'series' in val && 'xAxis' in val
    },
    // 备用 xAxis 数据
    chartdate: {
      type: Object,
      default: () => ({
        chartdatelist: ["工厂一", "工厂二"]
      })
    }
  },
  data() {
    return {
      chart: null
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.$nextTick(() => {
          this.setOptions(val);
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) return;
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, "macarons");
      this.setOptions(this.chartData);
    },

    setOptions(data = {}) {
      const seriesList = data.series || [];
      const xAxisData = data.xAxis || this.chartdate?.chartdatelist || ["工厂一", "工厂二"];
      const titleText = this.chartInfo?.title || "当日工厂生产进度统计";

      // 默认示例数据（计划 vs 实际）
      const defaultSeries = [
        { name: "计划数量", data: [100, 120] },
        { name: "实际数量", data: [80, 90] }
      ];

      const finalSeries = Array.isArray(seriesList) && seriesList.length > 0 ? seriesList : defaultSeries;
      const legendData = finalSeries.map(s => s.name);

      // 配色方案：蓝色（计划）、绿色（实际）
      const colors = ["#0089ff", "#5dbeac"];

      // 设置图表选项
      this.chart.setOption({
        title: {
          show: true,
          text: titleText,
          left: "center",
          textStyle: {
            color: "#333",
            fontWeight: "bolder",
            fontSize: 16
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          },
          formatter: (params) => {
            let res = params[0].name + "<br/>";
            params.forEach(p => {
              res += `${p.marker} ${p.seriesName}: ${p.value}<br/>`;
            });
            return res;
          }
        },
        grid: {
          left: 60,
          right: 30,
          bottom: 80,
          top: 50,
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: xAxisData,
          axisLine: {
            onZero: true,
            lineStyle: { color: "#ccc" }
          },
          splitLine: { show: false },
          axisTick: { show: true, alignWithLabel: true },
          axisLabel: {
            rotate: 0,
            interval: 0,
            margin: 10
          }
        },
        yAxis: {
          type: "value",
          // name: "数量",
          nameGap: 30,
          nameLocation: "middle",
          nameTextStyle: {
            fontWeight: "bold"
          },
          splitArea: { show: false }
        },
        legend: {
          data: legendData,
          right: "10%",
          top: "top",
          orient: "horizontal",
          textStyle: {
            fontWeight: "bold"
          }
        },
        series: finalSeries.map((item, index) => ({
          name: item.name,
          type: "bar",
          // 不设置 stack → 并排显示
          data: item.data,
          itemStyle: {
            color: colors[index % colors.length],
            borderRadius: [4, 4, 0, 0]
          },
          barWidth: '20%', // 设置柱子宽度为类目宽度的50%
          label: {
            show: true,
            position: "top",
            formatter: "{c}",
            fontSize: 12,
            fontWeight: "bold"
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(0,0,0,0.3)"
            }
          },
          animationDuration: 2000,
          animationEasing: "quinticInOut"
        }))
      });
    }
  }
};
</script>

<style scoped>
.chart {
  /* border: 1px solid #e0e0e0; */
  border-radius: 8px;
  padding: 10px;
  background-color: #fafafa;
}
</style>
